import API_URL from "../config/ApiUrl";

const API_BASE_URL = API_URL;
class ApiService {
  constructor() {
    this.baseURL = API_BASE_URL;
  }

  // Helper method for making requests
  async makeRequest(endpoint, options = {}) {
    console.log('REGISTER THE AUTH');
    const url = `${this.baseURL}${endpoint}`;

    console.log(url)
    
    const defaultOptions = {
      headers: {
        'Content-Type': 'application/json',
      },
      credentials: 'include',
    };

    const requestOptions = {
      ...defaultOptions,
      ...options,
      headers: {
        ...defaultOptions.headers,
        ...options.headers,
      },
    };
    console.log('REGISTER THE AUTH', requestOptions);

    try {
      const response = await fetch(url, requestOptions);
      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || `HTTP error! status: ${response.status}`);
      }

      return data;
    } catch (error) {
      console.error('API request failed:', error);
      throw error;
    }
  }

  // Authentication methods
  async register(userData) {
    console.log('REGISTER THE AUTH');
    return this.makeRequest('/api/register', {
      method: 'POST',
      credentials: 'include',
      body: JSON.stringify(userData),
    });
  }

  async login(credentials) {
    return this.makeRequest('/api/login', {
      method: 'POST',
      body: JSON.stringify(credentials),
    });
  }

  async logout() {
    return this.makeRequest('/api/logout', {
      method: 'POST',
    });
  }

  async getCurrentUser() {
    return this.makeRequest('/api/me');
  }

  async updateProfile(profileData) {
    return this.makeRequest('/api/update-profile', {
      method: 'PUT',
      body: JSON.stringify(profileData),
    });
  }

  async changePassword(passwordData) {
    return this.makeRequest('/api/change-password', {
      method: 'PUT',
      body: JSON.stringify(passwordData),
    });
  }

  // Product methods
  async getProducts() {
    return this.makeRequest('/api/get-products');
  }

  async getProduct(productId) {
    return this.makeRequest(`/api/get-product/${productId}`);
  }

  async addProduct(productData) {
    return this.makeRequest('/api/add-product', {
      method: 'POST',
      body: JSON.stringify(productData),
    });
  }

  // Review methods
  async addReview(reviewData) {
    return this.makeRequest('/api/add-review', {
      method: 'POST',
      body: JSON.stringify(reviewData),
    });
  }

  // Sesh Room methods
  async getSeshRooms() {
    return this.makeRequest('/api/get-sesh-rooms');
  }

  async getSeshRoom(roomData) {
    return this.makeRequest('/api/get/sesh-room', {
      method: 'POST',
      body: JSON.stringify(roomData),
    });
  }

  async addSeshRoom(roomData) {
    return this.makeRequest('/api/add-sesh-room', {
      method: 'POST',
      body: JSON.stringify(roomData),
    });
  }

  async joinSeshRoom(joinData) {
    return this.makeRequest('/api/join-sesh-room', {
      method: 'POST',
      body: JSON.stringify(joinData),
    });
  }

  async sendMessage(messageData) {
    return this.makeRequest('/api/send-message', {
      method: 'POST',
      body: JSON.stringify(messageData),
    });
  }
}
const forgotPassword = async (email) => {
  try {
    const response = await fetch(`${API_URL}/api/forgot-password`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ email }),
    });

    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error('Network error. Please try again.');
  }
};

const resetPassword = async (token, password) => {
  try {
    const response = await fetch(`${API_URL}/api/reset-password`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ token, password }),
    });

    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error('Network error. Please try again.');
  }
};

const verifyResetToken = async (token) => {
  try {
    const response = await fetch(`${API_URL}/api/verify-reset-token`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ token }),
    });

    const data = await response.json();
    return data;
  } catch (error) {
    throw new Error('Network error. Please try again.');
  }
};
// Create and export a singleton instance
const apiService = new ApiService();
export default apiService;

// Named exports for specific functionality
export const authApi = {
  register: (userData) => apiService.register(userData),
  login: (credentials) => apiService.login(credentials),
  logout: () => apiService.logout(),
  getCurrentUser: () => apiService.getCurrentUser(),
  updateProfile: (profileData) => apiService.updateProfile(profileData),
  changePassword: (passwordData) => apiService.changePassword(passwordData),
  forgotPassword,
  resetPassword,
  verifyResetToken
};

export const productApi = {
  getProducts: () => apiService.getProducts(),
  getProduct: (productId) => apiService.getProduct(productId),
  addProduct: (productData) => apiService.addProduct(productData),
};

export const reviewApi = {
  addReview: (reviewData) => apiService.addReview(reviewData),
};

export const seshRoomApi = {
  getSeshRooms: () => apiService.getSeshRooms(),
  getSeshRoom: (roomData) => apiService.getSeshRoom(roomData),
  addSeshRoom: (roomData) => apiService.addSeshRoom(roomData),
  joinSeshRoom: (joinData) => apiService.joinSeshRoom(joinData),
  sendMessage: (messageData) => apiService.sendMessage(messageData),
};